import { render, staticRenderFns } from "./FamilyAdminPage.vue?vue&type=template&id=1c340ec4&scoped=true&"
import script from "./FamilyAdminPage.vue?vue&type=script&lang=js&"
export * from "./FamilyAdminPage.vue?vue&type=script&lang=js&"
import style0 from "./FamilyAdminPage.vue?vue&type=style&index=0&id=1c340ec4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c340ec4",
  null
  
)

export default component.exports